<template>
    <psi-form-layout-section
        title="Program Details"
        :icon="$config('icons.program')"
        btn-label="Save Program Details"
        :btn-icon="$config('icons.program')"
        @section-save="save"
        :loading="sectionLoading.program"
    >
        <psi-form-section
            :ref="section.ref"
            :value="modelData"
            :name="section.name"
            label=""
            :fields="fields"
            color="secondary"
            @input="update"
        ></psi-form-section>
        <psi-form-element label="Icon/Logo" required>
            <v-card class="my-2">
                <v-card-text>
                    <v-avatar size="120" class="ma-3">
                        <img :src="modelData.icon_filepath" />
                    </v-avatar>
                    <v-tooltip top color="secondary">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="editDialog = true"
                                ><v-icon small class="mr-2">mdi-pencil</v-icon>
                                Edit
                            </v-btn>
                        </template>
                        <span>Change Program Logo/Icon</span>
                    </v-tooltip>
                </v-card-text>
            </v-card>
        </psi-form-element>
        <v-dialog v-model="editDialog" max-width="800" persistent>
            <program-icon-select
                v-if="editDialog"
                :icon_filepath="modelData.icon_filepath"
                @close="editDialog = false"
                @select="selectIconFile"
            >
            </program-icon-select>
        </v-dialog>
    </psi-form-layout-section>
</template>
<script>
import ProgramIcons from "@/components/program/mixins/programIcons";
export default {
    name: "program-details",
    mixins: [ProgramIcons],
    components: {
        ProgramIconSelect: () =>
            import("@/components/program/components/ProgramIconSelect"),
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        program: {
            type: Object,
            required: true,
        },
        sectionLoading: {
            type: Object,
            required: false,
            default: () => {
                return {
                    program: false,
                };
            },
        },
    },
    data() {
        return {
            editDialog: false,
            modelData: {},
            section: {
                ref: "program-details",
                name: "input-program-details",
            },
            fields: [
                {
                    type: "text",
                    name: "name",
                    placeholder: "Enter program name",
                    key: "name",
                    label: "Program Name",
                    icon: this.$config("icons.program"),
                    required: true,
                },
            ],
        };
    },
    computed: {},
    watch: {
        program: {
            immediate: true,
            handler(val) {
                if (Object.keys(val).length > 0) {
                    const { name, icon_filepath, id } = val;
                    this.modelData = { name, icon_filepath, id };
                }
            },
        },
    },
    methods: {
        update() {},
        selectIconFile(iconFilePath) {
            this.editDialog = false;
            this.modelData.icon_filepath = iconFilePath;
        },
        save() {
            if (this.$refs[this.section.ref].validate()) {
                if (this.modelData.id === 0) {
                    delete this.modelData.id; // we are creating the program
                }
                this.$emit("update", this.id, this.modelData);
            }
        },
    },
};
</script>

<style scoped>
</style>